var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9f9845a117dd6db620b77476af80332c0dc56cff"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"9f9845a117dd6db620b77476af80332c0dc56cff"};
      